import Vue from 'vue';
import Router from 'vue-router';
import authMiddleware from './middlewares/auth';
import insightMiddleware from './middlewares/insights';
import middlewarePipeline from './middlewares/pipeline';

Vue.use(Router);

const createRouter = () => new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/home'),
    },
    {
      path: '/login',
      component: () => import('@/pages/auth/login'),
      meta: {
        layout: 'blank',
        allowAnonymous: true,
      },
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('@/pages/account/account'),
    },
    {
      path: '/401',
      name: '401',
      component: () => import('@/pages/error/401'),
      meta: {
        layout: 'blank',
        allowAnonymous: true,
      },
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/pages/error/404'),
      meta: {
        layout: 'blank',
        allowAnonymous: true,
      },
    },
    {
      path: '/500',
      name: '500',
      component: () => import('@/pages/error/500'),
      meta: {
        layout: 'blank',
        allowAnonymous: true,
      },
    },
    {
      path: '/locked',
      name: 'locked',
      component: () => import('@/pages/error/locked'),
      meta: {
        layout: 'blank',
        allowAnonymous: true,
      },
    },
    {
      path: '/inactive',
      name: 'inactive',
      component: () => import('@/pages/error/inactive'),
      meta: {
        layout: 'blank',
        allowAnonymous: true,
      },
    },
    {
      path: '/authentication-fail',
      name: 'authentication-fail',
      component: () => import('@/pages/error/auth'),
      meta: {
        layout: 'blank',
        allowAnonymous: true,
      },
    },
  ],
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
});

const router = createRouter();

router.afterEach((route, from, to, next) => {
  const middleware = [];
  const context = {
    route,
    from,
    to,
    next,
    hook: 'after',
  };

  return insightMiddleware({
    ...context,
    next: middlewarePipeline(context, middleware, 0),
  });
});

router.beforeEach((to, from, next) => {
  const context = {
    to,
    from,
    next,
    hook: 'before',
  };

  if (to.matched.some(record => record.meta.allowAnonymous)) {
    return insightMiddleware({
      ...context,
      next: middlewarePipeline(context, [], 0),
    });
  }

  const middleware = to.meta.middleware || [];
  middleware.unshift(authMiddleware);

  return insightMiddleware({
    ...context,
    next: middlewarePipeline(context, middleware, 0),
  });
});

export function extendRouter(newRoutes) {
  router.addRoutes(newRoutes);
}

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js